import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/authContext';
import { Toast } from '../components/Auth/Toast';
import './AdminLoginPage.css';

function AdminLoginPage() {
  const [email, setEmail] = useState('arjun@gmail.com');
  const [password, setPassword] = useState('arjun@123');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect if already logged in as admin
    if (user && user.role === 'admin') {
      navigate('/admin/dashboard');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login({ email, password });

      if (result.success && result.user && result.user.role === 'admin') {
        setToast({
          type: 'success',
          message: '✅ Admin login successful!'
        });
        // Don't redirect here - let useEffect handle it
      } else {
        setToast({
          type: 'error',
          message: '❌ Only admin users can access this panel'
        });
      }
    } catch (error) {
      setToast({
        type: 'error',
        message: `❌ ${error.message || 'Login failed'}`
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-wrapper">
        {/* Left Side - Logo & Info */}
        <div className="admin-login-left">
          <div className="admin-login-content">
            <span className="admin-login-kicker">Latthsaab Network</span>
            <h1 className="admin-login-title">Laat Sahab News</h1>
            <p className="admin-login-subtitle">Admin Control Panel</p>
            <div className="admin-login-features">
              <div className="feature-item">
                <span className="feature-icon">VD</span>
                <p>Manage videos and homepage highlights</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">NW</span>
                <p>Publish stories across every admin route</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">LC</span>
                <p>Maintain locations, villages, and ticker updates</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="admin-login-right">
          <div className="admin-login-form-wrapper">
            <h2>Admin Login</h2>
            <p className="admin-login-subtext">Access your admin dashboard</p>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
              </div>

              <button
                type="submit"
                className="admin-login-btn"
                disabled={loading}
              >
                {loading ? '🔄 Logging in...' : '🔐 Login'}
              </button>
            </form>

            <div className="admin-login-footer">
              <p className="admin-login-note">Use an admin account to enter the protected editorial workspace.</p>
              <p className="demo-credentials">
                <strong>Demo Credentials:</strong>
                <br />
                Email: arjun@gmail.com
                <br />
                Password: arjun@123
              </p>
            </div>
          </div>
        </div>
      </div>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}

export default AdminLoginPage;
